import React from 'react';
import { motion } from 'framer-motion';
import { FaApple, FaAndroid, FaHourglassHalf } from 'react-icons/fa';
import { MdGamepad, MdArrowForward } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const platformIcons = { iOS: FaApple, Android: FaAndroid };

const GameContainer = ({ data }) => {
  const navigate = useNavigate();

  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-16 h-16 bg-gray-900 border border-white/5 rounded-2xl flex items-center justify-center mb-4">
          <MdGamepad className="text-gray-700 text-2xl" />
        </div>
        <p className="text-gray-500 font-bold text-sm">Bu kategoriye ait oyun bulunamadı.</p>
        <p className="text-gray-700 text-xs mt-1">Yakında yeni oyunlar ekleniyor!</p>
      </div>
    );
  }

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {data.map((game) => (
        <motion.div
          key={game.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          whileHover={{ y: -6 }}
          transition={{ type: 'spring', stiffness: 250 }}
          className="group bg-gray-900 border border-white/5 hover:border-headingColor/25 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-2xl hover:shadow-black/60"
          onClick={() => navigate(`/${game.slug}`)}
        >
          {/* Thumbnail */}
          <div className="relative h-52 overflow-hidden bg-gray-800">
            <img
              src={game.imageSrc}
              alt={game.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 opacity-90 group-hover:opacity-100"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent" />

            {/* genre badge */}
            <span className="absolute top-3 left-3 bg-gray-950/80 backdrop-blur-sm text-white text-[10px] font-bold px-2.5 py-1 rounded-full tracking-widest uppercase">
              {game.genre}
            </span>

            {/* status badge */}
            {game.status && (
              <span className="absolute top-3 right-3 inline-flex items-center gap-1.5 bg-yellow-500/15 backdrop-blur-sm border border-yellow-500/30 text-yellow-400 text-[10px] font-bold px-2.5 py-1 rounded-full tracking-widest uppercase">
                <FaHourglassHalf size={8} /> {game.status}
              </span>
            )}
          </div>

          {/* Info */}
          <div className="p-5">
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="min-w-0">
                <h3 className="text-white font-black text-base tracking-tight truncate">{game.name}</h3>
                {game.tagline && <p className="text-gray-600 text-xs mt-0.5 truncate">{game.tagline}</p>}
              </div>
              <MdArrowForward className="text-gray-700 group-hover:text-headingColor group-hover:translate-x-1 transition-all duration-200 text-xl shrink-0 mt-0.5" />
            </div>

            {/* short description */}
            {game.shortDescription && (
              <p className="text-gray-500 text-xs leading-relaxed mb-3 line-clamp-2">{game.shortDescription}</p>
            )}

            {/* platforms */}
            <div className="flex items-center justify-between">
              <div className="flex gap-1.5 flex-wrap">
                {game.platforms?.map(p => {
                  const Icon = platformIcons[p] || FaAndroid;
                  return (
                    <span key={p} className="inline-flex items-center gap-1 bg-white/5 border border-white/8 text-gray-500 text-[10px] px-2 py-0.5 rounded-full">
                      <Icon size={8} />{p}
                    </span>
                  );
                })}
              </div>
              {game.releaseDate && <span className="text-gray-700 text-[10px] font-semibold">{game.releaseDate}</span>}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default GameContainer;
